<template>
    <div>
        <UiModalsSignUpModal
            id="sbSignUpModal"
            class="sb-modal"
            :blok="blok"
            :form-state="formState"
            @submit="submitForm"
        />
    </div>
</template>

<script lang="ts" setup>
import type {
    ISignUpModalConfig,
    ISignUpFormData,
    ISignUpFormState,
} from '@nuxt-monorepo/ui/types/components/modals/SignUpModal';

const props = defineProps<{ blok: ISignUpModalConfig }>();

const formState = ref<ISignUpFormState>({
    success: false,
    isSubmitted: false,
    responseMsg: null,
});

const config = useRuntimeConfig();
const { $encodeBase64, $decodeBase64 } = useNuxtApp();
const returnUrl = config?.public.RETURN_URL;
const submitForm = async (formData: ISignUpFormData) => {
    formState.value.responseMsg = {};
    formState.value.success = false;
    formState.value.isSubmitted = false;

    await $publicApi('register', {
        method: 'POST',
        body: formData,
        onResponse: async ({ response }) => {
            if (response.ok) {
                formState.value.success = !!response._data.data?.success;
                formState.value.isSubmitted = true;
                const redirectSplit = response._data.redirect.split('&return_url=');
                console.error(
                    'Redirecting To:' +
                        (redirectSplit[0] + '&return_url=' + $encodeBase64($decodeBase64(returnUrl) + '/customer'))
                );
                navigateTo(redirectSplit[0] + '&return_url=' + $encodeBase64($decodeBase64(returnUrl) + '/customer'), {
                    external: true,
                });
            }
        },
        onResponseError: async ({ response }) => {
            if (response) {
                Object.keys(response._data?.errors).forEach((key) => {
                    formState.value.responseMsg[key] = response._data?.errors[key];
                });

                formState.value.success = false;
                formState.value.isSubmitted = true;
            }
        },
    }).catch((err: any) => console.error('Error in first API call:', err));
};
</script>

<style lang="postcss" scoped>
.sb-modal {
    :deep(.modal-dialog) {
        form {
            .newsletter {
                @apply font-medium leading-5 tracking-[0.066rem] text-sm mb-2;
            }

            .form-input {
                .input-label {
                    @apply hidden;
                }
                .error-message {
                    @apply mt-1 text-[0.775rem];
                }
                .form-element-wrap {
                    .form-element.has-error {
                        @apply text-[#ff3738];
                    }
                }
            }
        }
    }
}
</style>
